import { FC, ReactNode, useState } from 'react';
import { Authenticate } from '@consolidocs-ui/components';
import { Provider } from 'react-redux';
import store from '../../_services/Redux/store';
import Sidebar from '../Sidebar';
import IconButton from '@mui/joy/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { signInOptions } from '../../authConfig';
import { useAnalyticsUser } from './AppLayout.hooks';

interface MainLayoutProps {
  children: ReactNode;
}

/** Renders nothing; it only has to sit inside the signed-in tree. */
const AnalyticsUser: FC = () => {
  useAnalyticsUser();
  return null;
};

const MainLayout: FC<MainLayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div>
      {/* Outside the app shell, so the sign-in page gets the whole window. */}
      <Authenticate signIn={signInOptions}>
        <AnalyticsUser />
        <div className="main-content bg-[#f5f5f5] min-h-screen flex">
          <Provider store={store}>
            <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
            <div className="content flex-1 p-4" style={{ minWidth: 0 }}>
              <IconButton
                variant="outlined"
                color="neutral"
                size="sm"
                onClick={() => setSidebarOpen(true)}
                sx={{ display: { xs: 'inline-flex', md: 'none' }, mb: 1 }}
              >
                <MenuIcon />
              </IconButton>
              {children}
            </div>
          </Provider>
        </div>
      </Authenticate>
    </div>
  );
};

export default MainLayout;
